var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"blockchain-orders-container"},[_c('h1',[_vm._v("Blockchain Orders")]),_vm._v(" "),(_vm.orders)?_c('orders-table',{attrs:{"b-orders":_vm.orders,"loading":_vm.loading,"put-b-order":_vm.putBOrder}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-741b1b7a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/blockchainOrders/BlockchainOrders.vue
// module id = null
// module chunks = 